export default "skymp5-front/24f47c642fc63bf9f479df7cb8e4746a.wav";